import KeyAccountLayout from "@/layouts/KeyAccountLayout.vue";

import type { RouteRecordRaw } from "vue-router";

const repairFileRoutes: RouteRecordRaw[] = [
  {
    path: "/repair-files",
    name: "repairFiles",
    component: () =>
      import("@/views/restricted/repair-files/RepairFileListView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "repairFiles",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_VIEW_ALL_SUMMARY_REPAIR_FILE"],
    },
  },
  {
    path: "/repair-files/create",
    name: "repairFileCreate",
    component: () =>
      import("@/views/restricted/repair-files/RepairFileCreationLayoutView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "repairFiles",
      hideHeader: true,
      requiresAuth: true,
      permissions: [
        "KEY_ACCOUNT_ADD_REPAIR_FILE",
        "KEY_ACCOUNT_UPDATE_REPAIR_FILE",
      ],
    },
  },
  {
    path: "/repair-files/:repairFileBoomerangId/shipping",
    name: "repairFileShipping",
    component: () =>
      import("@/views/restricted/repair-files/RepairFileShippingView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "repairFiles",
      hideHeader: true,
      requiresAuth: true,
      permissions: [
        "KEY_ACCOUNT_VIEW_REPAIR_FILE",
        "KEY_ACCOUNT_ADD_REPAIR_FILE",
        "KEY_ACCOUNT_UPDATE_REPAIR_FILE",
      ],
    },
  },
  {
    path: "/repair-files/:repairFileBoomerangId/finalization",
    name: "repairFileFinalization",
    component: () =>
      import("@/views/restricted/repair-files/RepairFileFinalizationView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "repairFiles",
      hideHeader: true,
      requiresAuth: true,
      permissions: [
        "KEY_ACCOUNT_VIEW_REPAIR_FILE",
        "KEY_ACCOUNT_ADD_REPAIR_FILE",
        "KEY_ACCOUNT_UPDATE_REPAIR_FILE",
      ],
    },
  },
  {
    path: "/repair-files/:repairFileBoomerangId",
    name: "repairFileDetail",
    component: () =>
      import("@/views/restricted/repair-files/RepairFileDetailView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "repairFiles",
      hideHeader: true,
      requiresAuth: true,
      permissions: [
        "KEY_ACCOUNT_VIEW_REPAIR_FILE",
        "KEY_ACCOUNT_ADD_REPAIR_FILE",
        "KEY_ACCOUNT_UPDATE_REPAIR_FILE",
      ],
    },
  },
];

export default repairFileRoutes;
